<template>
  <div>
    <profile-app-bar />

    <v-snackbar :timeout="infoSnackbarTimeout" absolute bottom v-model="showInfoSnackbar">
      {{ snakbarInfoMessage }}
      <v-btn color="accent" text @click="showErrorSnackbar = false">Close</v-btn>
    </v-snackbar>

    <v-container fluid class="mt-12 px-12">
      <v-stepper v-model="step" class="mt-8">
        <v-stepper-header>
          <v-stepper-step
            edit-icon="mdi-check"
            :editable="stepIsComplete('edu', 1)"
            :complete="stepIsComplete('edu', 1)" 
            step="1">
            Education
          </v-stepper-step>
          <v-divider />

          <v-stepper-step 
            edit-icon="mdi-check"
            :editable="stepIsComplete('resume', 2)"
            :complete="stepIsComplete('resume', 2)"
            step="2">
            CV/Resume
          </v-stepper-step>
          <v-divider />

          <v-stepper-step 
          edit-icon="mdi-check"          
          :editable="stepIsComplete('motivation', 3)"
          :complete="stepIsComplete('motivation', 3)"
          step="3">
            Motivation Letter
          </v-stepper-step>
          <v-divider />

          <v-stepper-step 
            edit-icon="mdi-check"          
            :complete="stepIsComplete('reference', 4)"
            :editable="stepIsComplete('reference', 4)"
            step="4">
            Reference Letters
          </v-stepper-step>
          <v-divider />

          <v-stepper-step 
            edit-icon="mdi-check"          
            :complete="stepIsComplete('passport', 5)"
            :editable="stepIsComplete('passport', 5)"
            step="5">
            Passport
          </v-stepper-step>
          <v-divider />

          <v-stepper-step step="6">Submission</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <education ref="edu" />
            <v-btn 
              color="accent" 
              @click="nextButtonClicked('edu', 1)">
              Next
            </v-btn>
          </v-stepper-content>

          <v-stepper-content step="2">
            <resume ref="resume" />
            <v-btn 
              color="accent" 
              @click="nextButtonClicked('resume', 2)">
              Next
            </v-btn>            
          </v-stepper-content>

          <v-stepper-content step="3">
            <motivation-letter ref="motivation" />
            <v-btn color="accent" @click="nextButtonClicked('motivation', 3)">Next</v-btn>
          </v-stepper-content>

          <v-stepper-content step="4">
            <reference-letters ref="reference" />
            <v-btn color="accent" @click="nextButtonClicked('reference', 4)">Next</v-btn>
          </v-stepper-content>

          <v-stepper-content step="5">
            <passport ref="passport" />
            <v-btn color="accent" @click="nextButtonClicked('passport', 5)">Next</v-btn>
          </v-stepper-content>

          <v-stepper-content step="6">
            <app-submission ref="submission" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-container>
  </div>
</template>


<script>
import Education from "../components/Education";
import Resume from "../components/CV";
import MotivationLetter from "../components/MotivationLetter";
import ReferenceLetters from "../components/ReferenceLetters";
import Passport from "../components/Passport";
import AppSubmission from "../components/AppSubmission";
import { mapActions } from "vuex";
import { mapFields } from "vuex-map-fields";
import ProfileAppBar from "../components/ProfileAppBar";
import submissionMixin from "../mixins/submission.mixin";

export default {
  name: "SubmissionScreen",
  // TODO: put all components in one folder
  // create index.js file and load them with { ...components }
  components: {
    Education,
    Resume,
    MotivationLetter,
    ReferenceLetters,
    Passport,
    AppSubmission,
    ProfileAppBar
  },
  mixins: [submissionMixin],
  computed: {
    ...mapFields("profile", {
      isComplete: "profile.isComplete",
      profilePicUrl: "profile.photo.url",
      name: "profile.name"
    }),
    isFirstStep() {
      const currentStep = this.getCurrentStep();
      const currentStepIndex = this.steps.indexOf(currentStep);
      return currentStepIndex === 0;
    },
    isLastStep() {
      const currentStep = this.getCurrentStep();
      const currentStepIndex = this.steps.indexOf(currentStep);
      return currentStepIndex === this.steps.length - 1;
    }
  },
  created() {

  },
  data() {
    return {
      step: 1,
      whichComp: "Education",
      steps: [
        {
          title: "Education",
          type: "edu",
          enabled: true,
          component: "Education"
        },
        {
          title: "CV",
          type: "cv",
          enabled: false,
          component: "CV"
        },
        {
          title: "Motivation Letter",
          type: "motiviationLetter",
          enabled: false,
          component: "MotivationLetter"
        },
        {
          title: "Refrence Letters",
          type: "refLetter",
          enabled: false,
          component: "ReferenceLetters"
        },
        {
          title: "Passport",
          type: "passport",
          enabled: false,
          component: "Passport"
        },
        {
          title: "Submission",
          type: "applicationSubmission",
          enabled: false,
          component: "AppSubmission"
        }
      ]
    };
  },
  methods: {
    ...mapActions("profile", ["setProfile"]),
    ...mapActions("auth", ["logoutUser"]),

    async onLogout() {
      try {
        await this.logoutUser();
      } finally {
        // logout user and route him to the
        // welcome screen
        this.$router.replace({
          name: "welcome"
        });

        this.setProfile(null);
      }
    },

    stepClass(step) {
      const currentStepIndex = this.steps.indexOf(this.getCurrentStep());
      const stepIndex = this.steps.indexOf(step);
      return stepIndex < currentStepIndex ? "step-clickable" : "step-default";
    },

    stepClicked(step, force = false) {
      // allow user to navigate only to previous
      // step when he clicked on the step tab
      // if the force is equal to true
      // then we will allow to navigate to the step
      // without any conditions

      const currentStep = this.getCurrentStep();

      if (!force) {
        const currentStepIndex = this.steps.indexOf(currentStep);
        const nextStepIndex = this.steps.indexOf(step);
        if (nextStepIndex > currentStepIndex) {
          return;
        }
      }

      this.steps.forEach(step => {
        step.enabled = false;
      });

      step.enabled = true;

      this.whichComp = step.component;
    },

    stepIsComplete(ref, step){

      if (!this.$refs[ref]){
        return false;
      }

      // if we currently on the step
      // then we will not mark it as complete
      if (step >= this.step){
        return false;
      }

      // check that the step is valid 
      const isValid = this.$refs[ref].validateForm();

      // if the step is valid
      // it indicates that the step is complete
      return isValid;
    },

    nextButtonClicked(ref, step) {

      const isValid = this.$refs[ref].validateForm();

      if (!isValid) {
        return;
      }

      const nextStep = step + 1;


      this.step = nextStep;

      // const nextStep = this.getNextStep();
      // render the next step component
      // do we need to validate if the user completed the current step
      // before go to the next one?
      // this.stepClicked(nextStep, true);
    },

    prevButtonClicked() {
      this.step = this.step - 1;
      // // go to previous step
      // const currentStepIndex = this.steps.indexOf(this.getCurrentStep());
      // const prevStepIndex = currentStepIndex - 1;
      // if (prevStepIndex >= 0) {
      //   this.stepClicked(this.steps[prevStepIndex], true);
      // }
    },

    getNextStep() {
      const currentStep = this.getCurrentStep();

      const currentStepIndex = this.steps.indexOf(currentStep);
      // next step is the current step + 1
      const nextStepIndex = currentStepIndex + 1;

      return this.steps[nextStepIndex];
    },

    getCurrentStep() {
      const currentStep = this.steps.filter(step => step.enabled)[0];
      return currentStep;
    }
  }
};
</script>

<style lang="scss" scoped>
.step {
  height: 80px;
  line-height: 1.2;
  &-enabled {
    background: #3ad29f;
    color: white;
  }

  &-disabled {
    background: #ebf0f2;
    color: black;
  }

  &-clickable {
    cursor: pointer;
  }

  &-default {
    cursor: default;
  }
}
</style>